<div class="container-table">
  <mat-table
    #table
    class="table table-p1 borderless align-middle"
    matSortDisableClear
    [dataSource]="dataSource"
    matSort
    matSortDirection="desc"
  >
    <ng-container matColumnDef="companyName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Informações do cliente</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Informações do cliente </span>

        <div class="client-info">
          <p
            *ngIf="row?.companyName"
            class="tappable label-desktop company-name"
            [title]="row?.companyName"
            (click)="openClientDetailsModal(row)"
          >
            {{ row?.companyName }}
          </p>
          <p
            *ngIf="row?.name"
            class="tappable label-desktop company-name"
            [title]="row?.name"
            (click)="openClientDetailsModal(row)"
          >
            {{ row?.name }}
          </p>

          <div class="client-document">
            <span
              *ngIf="row?.document?.length === 14"
              class="label-desktop document-text"
            >
              {{ row?.document | mask : "AA.AAA.AAA/AAAA-00" }}
            </span>
            <span
              *ngIf="row?.document?.length === 11"
              class="label-desktop document-text"
            >
              {{ row?.document | mask : "000.000.000-00" }}
            </span>
          </div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="agencyNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Agência</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Agência:</span>

        <span
          *ngIf="row?.businessPartner?.agencyNumber"
          class="label-desktop label-data"
        >
          {{ row?.businessPartner?.agencyNumber }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="situation">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Sit. Cadastral</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Sit. Cadastral:</span>

        <div class="situation-container" *ngIf="row?.situation">
          <img
            [src]="getSituationIcon(row.situation)"
            alt=""
            class="situation-icon"
          />
          <span class="situation-label {{ getSituationClass(row.situation) }}">
            {{ getSituationLabel(row.situation) }}
          </span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="spread">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Spread</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Spread:</span>

        <div>
          <span *ngIf="!row?.isDefaultSpread" class="label-desktop label-data">
            Personalizado ({{ row?.spread }}%)
          </span>
          <span *ngIf="row?.isDefaultSpread" class="label-desktop label-data">
            Padrão ({{ row?.spread }}%)
          </span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tariff">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Tarifa</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Tarifa:</span>

        <div>
          <span *ngIf="row?.isDefaultTariff" class="label-desktop label-data">
            Padrão ({{ row?.tariff | brl }})
          </span>
          <span *ngIf="!row?.isDefaultTariff" class="label-desktop label-data">
            Personalizada ({{ row?.tariff | brl }})
          </span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Status</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Status:</span>

        <div class="status-tag-container">
          <span
            *ngFor="let statusItem of row?.status"
            class="status-tag {{ getStatusClass(statusItem) }}"
          >
            {{ getStatusLabel(statusItem) }}
          </span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>
        <p class="label-desktop">Ações</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <img
          src="assets/icons/table-config.svg"
          alt="Configurar"
          class="tappable action-icon"
          (click)="openClientConfigModal(row)"
        />
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; let i = index; columns: displayedColumns">
    </mat-row>
  </mat-table>
</div>

<mat-paginator
  class="custom-paginator"
  [pageIndex]="pageNumber"
  [pageSize]="pageSize"
  [length]="totalElements"
  (page)="chanePageEvent($event)"
  [pageSizeOptions]="[5, 10, 25, 100]"
  showFirstLastButtons
></mat-paginator>
